import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// Danh sách các storage keys cần clear
const STORAGE_KEYS = {
  jobListState: '/job-management',
  articleListState: '/articles-management', 
  trainingListState: '/training-management',
  bodInterviewListState: '/bod-interview-management',
  candidateTestState: '/test-management',
  testListState: '/test-management'
};

export const useClearAllSessionStorage = () => {
  const location = useLocation();
  const isFirstLoad = useRef(true);
  const previousPath = useRef<string>('');

  useEffect(() => {
    const path = location.pathname;
    
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      previousPath.current = path;
      return;
    }

    // Lấy path trước đó
    const previousPathValue = previousPath.current;
    
    // Kiểm tra xem có phải đang thoát khỏi một route nào đó không
    Object.entries(STORAGE_KEYS).forEach(([storageKey, routePath]) => {
      const wasInRoute = previousPathValue.startsWith(routePath);
      const isInRoute = path.startsWith(routePath);
      
      // Chỉ clear khi thoát khỏi route đó
      if (wasInRoute && !isInRoute) {
        sessionStorage.removeItem(storageKey);
      }
    });
    
    // Cập nhật previous path
    previousPath.current = path;
  }, [location]);

  return null;
};
